import React from "react"
import { useSelector, useDispatch } from 'react-redux'
import {loadVideos} from "../../redux/videoSlice"
import { globals} from '../Globals/Globals';
import MediaPlayer from "../MediaPlayer/MediaPlayer";

const HomeVideo = (props) => {
    const {videosItems, loadVideos_result} = useSelector((state) => state.video);
    const dispatch = useDispatch();

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true
    
        if (loadVideos_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("HomeVideo::Loading video...")
            dispatch(loadVideos());
        }

        if (loadVideos_result.status === "idle"){
            if (globals.parameters.debugging)
                console.log("HomeVideo::Loading video...")
            dispatch(loadVideos());
        }

        // Cleanup function
        return () => {
            isMounted = false
        }
    }, [loadVideos_result, dispatch]);

           
    return(<MediaPlayer 
        youtubeID_or_MP4url={
            (loadVideos_result.status === "succeeded" && videosItems && videosItems.length>=(props.video_index) && videosItems[props.video_index])?videosItems[props.video_index].data_blob.data_tier.youtube_id:null}/>)
}

export default HomeVideo